<template>
    <div>
        <Modal v-model="mainTable.sarchCardShow"
            title="搜索条件"
            :width="1000"
            footer-hide>
            <search-card :form="mainTable.searchForm"
                :table-load-event="getSaleStatList"
                :table-search="mainTable.tableSearch" />
        </Modal>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">销售提成统计</span>
                        <span style="margin-left:20px;">统计时间:</span>
                        <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width: 200px"
                            @on-change="onDateChange"></DatePicker>
                        <RadioGroup v-model="groupBy"
                            style="margin-left:20px;"
                            type="button"
                            size="small"
                            @on-change="onGroupByChange">
                            <Radio label="manager"> <span>按客户经理</span> </Radio>
                            <Radio label="other"> <span>按IT/客服</span> </Radio>
                        </RadioGroup>

                        <RadioGroup v-if="groupBy == 'manager'"
                            v-model="projectType"
                            style="margin-left:20px;"
                            type="button"
                            size="small"
                            @on-change="onProjectTypeChange">
                            <Radio label="市场部门"> <span>市场部门</span> </Radio>
                            <Radio label="非市场部门"> <span>种苗网基金</span> </Radio>
                        </RadioGroup>

                        <RadioGroup v-model="subGroupBy"
                            style="margin-left:20px;"
                            type="button"
                            size="small"
                            @on-change="onGroupByChange">
                            <Radio label="all"> <span>全部</span> </Radio>
                            <Radio label="seedFarm"> <span>苗场</span> </Radio>
                            <Radio label="mainCate"> <span>大类</span> </Radio>
                            <Radio label="subCate"> <span>小类</span> </Radio>
                        </RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.statColumns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getSaleStatList"
                    :extHeight="-50"
                    :showPage="false" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="commissionDetailModal.show"
            title="提成明细"
            :width="1200"
			:closable = "false"
            footer-hide>
			
			<Row :gutter="16" type="flex" style="margin-bottom: 20px; align-items: center;">
				<Col span="16">
					<search-card :form="commissionDetailModal.searchForm"
						:table-load-event="showCommissionDetail"
						:table-search="commissionDetailModal.tableSearch"
						 style="border: none;"/>
				</Col>		
				<Col span="8" style="text-align: right;">
					<Button type="info"
						    size='small'
						    class="btns"
						    shape="circle"
						    icon="ios-send"
						    @click="onExport()">导出</Button>
				</Col>
			</Row>
			<Row :gutter="16">
			    <Col span="24">
					<stand-pagination-table :columns="commissionDetailModal.preSaleColumns"
						:data="commissionDetailModal.preSaleData"
						:loading="commissionDetailModal.loading"
						:table-search="commissionDetailModal.tableSearch"
						:table-load-event="showCommissionDetail"
						:autoHeight="true"
						:showPage="true" />
			    </Col>
			</Row>
			<div slot="header" class="div-header">
				<Button class="btn-font" type="text" @click="cancal">✕</Button>
			</div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import { numberToFixed, number2ThousandsFormat, getNumberThousandString } from '@/components/number-input/display-format';
import { getThisMonthStart, getTodayDateString, formatDateString } from '@/libs/logic';
import { getCombineCommission, getCombineCommissionDetail } from '@/api/modules/finance-management/commission';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
export default {
    name: 'SaleStatList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            userType:'F',
            groupBy: 'manager',
            subGroupBy: 'all',
            projectType: '市场部门',
            selectDates: [],
            commissionDetailModal: {
                uuid: '',
                subName: '',
                show: false,
                loading: false,
                tableSearch: search.getSearchParams(),
                preSaleData: [],
                preSaleColumns: [
                    { title: '定单编号', key: 'depositBillRecordCode', width: 160, align: 'center', excel: true },
                    { title: '客户名称', key: 'orderOwerPersonName', width: 60, align: 'center', excel: true },
                    { title: '客户账号', key: 'orderOwner', width: 60, align: 'center', excel: true },
                    { title: '电话', key: 'userPhone', width: 100, align: 'center', excel: true },
                    { title: '默认地址', key: 'memberDeliveryAddressFull', width: 120, align: 'center', excel: true },
                    { title: '商品编号', key: 'productCode', width: 60, align: 'center', excel: true },
                    { title: '商品名称', key: 'productName', width: 100, align: 'center', excel: true },
                    { title: '单价', key: 'preSaleDeliveryDetailActProductPrice', width: 80, align: 'center', excel: true },
                    { title: '数量', key: 'preSaleDeliveryDetailQuantity', width: 80, align: 'center', excel: true },
                    { title: '销售金额', key: 'deliveryValue', width: 80, align: 'center', excel: true },
                    { title: '优惠金额', key: 'saleDiscountValue', width: 80, align: 'center', excel: true },
                    { title: '代金券', key: 'voucherAmount', width: 80, align: 'center', excel: true },
                    { title: '退货金额', key: 'refundTotalVal', width: 80, align: 'center', excel: true },
                    { title: '有效金额', key: 'saleRealValue', width: 80, align: 'center', excel: true },
                    { title: '佣金比例（%）', key: 'commissionRate', width: 60, align: 'center', excel: true },
                    { title: '佣金提成', key: 'managerCommission', width: 60, align: 'center', excel: true },
                    { title: '经理', key: 'managerName', width: 60, align: 'center', excel: true },
                    { title: '苗场发货日期', key: 'preSaleDeliveryRecordDeliveryDate', width: 100, align: 'center', render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate), excel: true },
                    { title: '转运站发货日期', key: 'stationDeliveryDate', width: 100, align: 'center', render: (h, params) => dateRender(h, params.row.stationDeliveryDate), excel: true }
                ],
                searchForm:[
                    { label: '客户名称', type: 'Input', value: '', name: 'users.userPersonName ', sql: 'like' },
                    { label: '客户账号', type: 'Input', value: '', name: 'users.userName ', sql: 'like' },
                    { label: '电话', type: 'Input', value: '', name: 'userPhone ', sql: 'like' }
                ]
            },
            mainTable: {
                statColumns: [],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        reSetColumns(){
            if(this.subGroupBy=="all"||this.subGroupBy=="seedFarm"){
                this.mainTable.statColumns=[{ title: '统计项', key: 'groupName', align: 'center' },
                    { title: '部门', key: 'dept', align: 'center' },
                    { title: '区域', key: 'company', align: 'center' },
                    { 
                        title: '收款量',
                        key: 'preSaleCount',
                        align: 'center', 
                        render: (h, params) => {
                            const preSaleCount = params.row.preSaleCount ? params.row.preSaleCount : 0;
                            return h('span', {}, getNumberThousandString(preSaleCount, 0, ''));
                        }
                    },
                    {
                        title: '发货量', 
                        key: 'totalReceiveQuantity',
                        align: 'center',  
                        render: (h, params) => {
                            const totalReceiveQuantity = params.row.totalReceiveQuantity ? params.row.totalReceiveQuantity : 0;
                            return h('span', {}, getNumberThousandString(totalReceiveQuantity, 0, ''));
                        }
                    },                    
                    {
                        title: '销售金额',
                        key: 'preSaleValue',
                        align: 'center',
                        render: (h, params) => {
                            const preSaleValue = params.row.preSaleValue ? params.row.preSaleValue : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(preSaleValue, 2, ''))
                            ]);
                        }
                    },
                    {
					    title: '优惠金额',
					    key: 'saleDiscountValue',
					    align: 'center',
					    render: (h, params) => {
					        const saleDiscountValue = params.row.saleDiscountValue ? params.row.saleDiscountValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleDiscountValue, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '代金券',
					    key: 'voucherAmount',
					    align: 'center',
					    render: (h, params) => {
					        const voucherAmount = params.row.voucherAmount ? params.row.voucherAmount : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(voucherAmount, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '退货金额',
					    key: 'refundTotalVal',
					    align: 'center',
					    render: (h, params) => {
					        const refundTotalVal = params.row.refundTotalVal ? params.row.refundTotalVal : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(refundTotalVal, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '有效金额',
					    key: 'saleRealValue',
					    align: 'center',
					    render: (h, params) => {
					        const saleRealValue = params.row.saleRealValue ? params.row.saleRealValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleRealValue, 2, ''))
					        ]);
					    }
                    },
                    {
                        title: '提成',
                        key: 'preSaleCommission',
                        align: 'center',
                        render: (h, params) => {
                            const preSaleCommission = params.row.preSaleCommission ? params.row.preSaleCommission : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(preSaleCommission, 2, ''))
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style:{
                                        visibility: params.row.groupName=='合计'? 'hidden' : 'visible'
                                    },
                                    on: {
                                        click: () => {
                                            this.showCommissionDetail(params.row.uuid, params.row.subName);
                                        }
                                    }
                                }, '查看明细')
                            ]);
                        }
                    }];
            }
            else{
                this.mainTable.statColumns=[{ title: '统计项', key: 'groupName', align: 'center' },
				    { title: '部门', key: 'dept', align: 'center' },
				    { title: '区域', key: 'company', align: 'center' },
                    { 
                        title: '收款量',
                        key: 'preSaleCount',
                        align: 'center', 
                        render: (h, params) => {
                            const preSaleCount = params.row.preSaleCount ? params.row.preSaleCount : 0;
                            return h('span', {}, getNumberThousandString(preSaleCount, 0, ''));
                        }
                    },
                    {
                        title: '发货量', 
                        key: 'totalReceiveQuantity',
                        align: 'center',  
                        render: (h, params) => {
                            const totalReceiveQuantity = params.row.totalReceiveQuantity ? params.row.totalReceiveQuantity : 0;
                            return h('span', {}, getNumberThousandString(totalReceiveQuantity, 0, ''));
                        }
                    },                     
				    {
				        title: '销售金额',
				        key: 'preSaleValue',
				        align: 'center',
				        render: (h, params) => {
				            const preSaleValue = params.row.preSaleValue ? params.row.preSaleValue : 0;
				            return h('div', {}, [
				                h('span', {}, number2ThousandsFormat(preSaleValue, 2, ''))
				            ]);
				        }
				    },
                    {
					    title: '优惠金额',
					    key: 'saleDiscountValue',
					    align: 'center',
					    render: (h, params) => {
					        const saleDiscountValue = params.row.saleDiscountValue ? params.row.saleDiscountValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleDiscountValue, 2, ''))
					        ]);
					    }
                    },
                                        {
					    title: '代金券',
					    key: 'voucherAmount',
					    align: 'center',
					    render: (h, params) => {
					        const voucherAmount = params.row.voucherAmount ? params.row.voucherAmount : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(voucherAmount, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '退货金额',
					    key: 'refundTotalVal',
					    align: 'center',
					    render: (h, params) => {
					        const refundTotalVal = params.row.refundTotalVal ? params.row.refundTotalVal : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(refundTotalVal, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '有效金额',
					    key: 'saleRealValue',
					    align: 'center',
					    render: (h, params) => {
					        const saleRealValue = params.row.saleRealValue ? params.row.saleRealValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleRealValue, 2, ''))
					        ]);
					    }
                    },
				    {
				        title: '提成',
				        key: 'preSaleCommission',
				        align: 'center',
				        render: (h, params) => {
				            const preSaleCommission = params.row.preSaleCommission ? params.row.preSaleCommission : 0;
				            return h('div', {}, [
				                h('span', {}, number2ThousandsFormat(preSaleCommission, 2, ''))
				            ]);
				        }
				    },
				    {
				        title: '操作',
				        key: 'action',
				        align: 'center',
				        width: 80,
				        render: (h, params) => {
				            return h('div', [
				                h('Button', {
				                    props: {
				                        type: 'text',
				                        size: 'small',
				                        shape: 'circle'
				                    },
                                    style:{
                                        visibility: params.row.groupName=='合计'? 'hidden' : 'visible'
                                    },
				                    on: {
				                        click: () => {
				                            this.showCommissionDetail(params.row.uuid, params.row.subName);
				                        }
				                    }
				                }, '查看明细')
				            ]);
				        }
				    }];
            }
        },
        reSetsearchForm(){
            let userPersonNameValue=this.getSearchFormValue('userPersonName');
            let seedFarmNameValue=this.getSearchFormValue('seedFarmName');
            let userCustomerManagerNameValue=this.getSearchFormValue('userCustomerManagerName');
            let mainCategoryNameValue=this.getSearchFormValue('mainCategoryName');
            let subCategoryNameValue=this.getSearchFormValue('subCategoryName');
            let productNameValue=this.getSearchFormValue('productName');

            if(this.subGroupBy=="all"||this.subGroupBy=="seedFarm"){
                this.mainTable.searchForm=[{ label: '会员', type: 'Input', value: userPersonNameValue, name: 'userPersonName', sql: 'like' },
				    { label: '苗场', type: 'Input', value: seedFarmNameValue, name: 'seedFarmName', sql: 'like' },
				    { label: '客户经理', type: 'Input', value: userCustomerManagerNameValue, name: 'userCustomerManagerName', sql: 'like' }];
            }
            else{
                this.mainTable.searchForm=[{ label: '会员', type: 'Input', value: userPersonNameValue, name: 'userPersonName', sql: 'like' },
				    { label: '苗场', type: 'Input', value: seedFarmNameValue, name: 'seedFarmName', sql: 'like' },
				    { label: '大类', type: 'Input', value: mainCategoryNameValue, name: 'mainCategoryName', sql: 'like' },
				    { label: '小类', type: 'Input', value: subCategoryNameValue, name: 'subCategoryName', sql: 'like' },
				    { label: '客户经理', type: 'Input', value: userCustomerManagerNameValue, name: 'userCustomerManagerName', sql: 'like' },
				    { label: '商品信息', type: 'Input', value: productNameValue, name: 'productName', sql: 'like' }];
            }
        },
        getSearchFormValue(name){
            let search= this.mainTable.searchForm.find(x=>x.name==name);
            if(!search){
                return '';
            }
            return search.value;
        },
        getTodayDateString,
        getThisMonthStart,
        formatDateString,
        dateRender,
        cancal(){
            this.commissionDetailModal.tableSearch.limit.conditions.pageStart=1;
            this.commissionDetailModal.tableSearch.limit.conditions.pageLength = 10;
            this.commissionDetailModal.show = false; 
        },
        init() {
            this.getSaleStatList();
        },
        onExport() {
            let tempSearch = search.getSearchParams();
            if (this.userType) {
            	search.globalRemoveFilterConditionKey(tempSearch, "memberType");
            	tempSearch.filters.enable = true;
            	tempSearch.filters.conditions.push({
            		name: 'memberType',
            		type: 'eq',
            		value: this.userType
            	});
            }
            tempSearch.limit.enable = false;
            tempSearch.groupBy = this.groupBy;
            tempSearch.subGroupBy = this.subGroupBy;
            tempSearch.beginDate = this.selectDates[0];
            tempSearch.endDate = this.selectDates[1];
            tempSearch.uuid = this.commissionDetailModal.uuid;
            tempSearch.subName = this.commissionDetailModal.subName;

            tempSearch.excelExport.enable = true;
            tempSearch.excelExport.columns = this.commissionDetailModal.preSaleColumns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.commissionDetailModal.loading = true;
            getCombineCommissionDetail(tempSearch).then(res => {
                this.commissionDetailModal.loading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                }
            });
        },
        showCommissionDetail(uuid, subName) {
            let tempSearch = this.commissionDetailModal.tableSearch;
            if (this.userType) {
                search.globalRemoveFilterConditionKey(tempSearch, "memberType");
                tempSearch.filters.enable = true;
                tempSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            tempSearch.groupBy = this.groupBy;
            tempSearch.subGroupBy = this.subGroupBy;
            tempSearch.beginDate = this.selectDates[0];
            tempSearch.endDate = this.selectDates[1];
            if (uuid) {
			    tempSearch.uuid = uuid;
			    tempSearch.subName = subName;
			    this.commissionDetailModal.uuid = uuid;
                this.commissionDetailModal.subName = subName;
            }
            else{
                tempSearch.uuid = this.commissionDetailModal.uuid;
                tempSearch.subName = this.commissionDetailModal.subName;
            }
            
            this.commissionDetailModal.show = true;
            this.commissionDetailModal.loading = true;
            getCombineCommissionDetail(tempSearch).then(res => {
                this.commissionDetailModal.loading = false;
                if (res.code === 0) {
                    this.commissionDetailModal.preSaleData = res.data.combineSatInfoList;

                    let totalQuantity = 0;
                    let totalDeliveryValue = 0;
                    let totalManagerCommission=0;
                    let totalSaleDiscountValue = 0;
                    let totalRefundTotalVal = 0;
                    let totalSaleRealValue = 0;
                    let totalVoucherAmount = 0;
                    this.commissionDetailModal.preSaleData.forEach(e => {
                        totalQuantity += e.preSaleDeliveryDetailQuantity;
                        totalDeliveryValue += e.deliveryValue;
                        totalManagerCommission += e.managerCommission;
                        totalSaleDiscountValue += e.saleDiscountValue;
                        totalRefundTotalVal += e.refundTotalVal;
                        totalSaleRealValue += e.saleRealValue;
                        totalVoucherAmount += e.voucherAmount;
                    });
                    this.commissionDetailModal.preSaleData.push({
                        preSaleDeliveryDetailQuantity: numberToFixed(totalQuantity, 2),
                        deliveryValue: numberToFixed(totalDeliveryValue, 2),
                        saleDiscountValue: numberToFixed(totalSaleDiscountValue, 2),
                        refundTotalVal: numberToFixed(totalRefundTotalVal, 2),
                        saleRealValue: numberToFixed(totalSaleRealValue, 2),
                        managerCommission: numberToFixed(totalManagerCommission, 2),
                        voucherAmount: numberToFixed(totalVoucherAmount, 2),
                        productName: '本页合计'
                    });
                    this.commissionDetailModal.preSaleData.push({
					    preSaleDeliveryDetailQuantity: numberToFixed(res.data.listCombine[0].totalMainQuantity, 2),
					    deliveryValue: numberToFixed(res.data.listCombine[0].totalMainDeliveryValue, 2),
                        saleDiscountValue: numberToFixed(res.data.listCombine[0].totalMainSaleDiscountValue, 2),
                        refundTotalVal: numberToFixed(res.data.listCombine[0].totalRefundTotalVal, 2),
                        saleRealValue: numberToFixed(res.data.listCombine[0].totalMainSaleRealValue, 2),
					    managerCommission: numberToFixed(res.data.listCombine[0].totalMainManagerCommission, 2),
                        voucherAmount: numberToFixed(res.data.listCombine[0].totalMainVoucherAmount, 2),
					    productName: '总合计'
                    }); 
                    search.globalSetFilterRecordCount(this.commissionDetailModal.tableSearch, res.data.filterRecordCount);
                }
            });
        },
        onSaleChage(e) {
            this.getSaleStatList(true);
        },
        onGroupByChange(e) {
            this.mainTable.tableSearch.filters.conditions=[];
            this.commissionDetailModal.tableSearch.filters.conditions=[];
            this.getSaleStatList();
        },
        onProjectTypeChange(e) {
            this.getSaleStatList();
        },
        onDateChange() {
            this.getSaleStatList();
        },
        getSaleStatList(reset = false) {
            this.reSetColumns();
            this.reSetsearchForm();
            search.globalSetFilterWithSearchForm(this.mainTable.tableSearch, search.filterForm(this.mainTable.searchForm));
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
            	search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
            	this.mainTable.tableSearch.filters.enable = true;
            	this.mainTable.tableSearch.filters.conditions.push({
            		name: 'memberType',
            		type: 'eq',
            		value: this.userType
            	});
            }
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            this.mainTable.tableSearch.subGroupBy = this.subGroupBy;
            this.mainTable.tableSearch.projectType = this.projectType;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];

            getCombineCommission(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                this.mainTable.sarchCardShow=false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.listCombine;
                    let curSaleCountAll = 0;
                    let curSaleValueAll = 0;
                    let curSaleCommissionAll = 0;
                    let curSaleCommissionFixedAll = 0;
                    let preSaleCountAll = 0;
                    let totalReceiveQuantityAll=0;
                    let preSaleValueAll = 0;
                    let preSaleCommissionAll = 0;
                    let combineCommissionAll = 0;
                    let combineCommissionFixedAll = 0;
                    let commissionBackAll = 0;
                    let saleDiscountValueAll = 0;
                    let refundTotalValAll = 0;
                    let saleRealValueAll = 0;
                    let voucherAmountAll = 0;
                    this.mainTable.data.forEach(e => {
                        curSaleCountAll += e.curSaleCount;
                        curSaleValueAll += e.curSaleValue;
                        curSaleCommissionAll += e.curSaleCommission;
                        preSaleCountAll += e.preSaleCount;
                        totalReceiveQuantityAll+=e.totalReceiveQuantity;
                        preSaleValueAll += e.preSaleValue;
                        preSaleCommissionAll += e.preSaleCommission;
                        combineCommissionAll += e.combineCommission;
                        commissionBackAll += e.commissionBack;
                        saleDiscountValueAll += e.saleDiscountValue;
                        refundTotalValAll += e.refundTotalVal;
                        saleRealValueAll += e.saleRealValue;
                        voucherAmountAll += e.voucherAmount;
                    });
                    this.mainTable.data.push({
                        curSaleCount: numberToFixed(curSaleCountAll, 3),
                        curSaleValue: numberToFixed(curSaleValueAll, 3),
                        curSaleCommission: numberToFixed(curSaleCommissionAll, 3),
                        preSaleCount: numberToFixed(preSaleCountAll, 3),
                        totalReceiveQuantity: numberToFixed(totalReceiveQuantityAll, 3),
                        preSaleValue: numberToFixed(preSaleValueAll, 3),
                        preSaleCommission: numberToFixed(preSaleCommissionAll, 3),
                        combineCommission: numberToFixed(combineCommissionAll, 3),
                        commissionBack: numberToFixed(commissionBackAll, 3),
                        saleDiscountValue: numberToFixed(saleDiscountValueAll, 3),
                        refundTotalVal: numberToFixed(refundTotalValAll, 3),
                        saleRealValue: numberToFixed(saleRealValueAll, 3),
                        voucherAmount: numberToFixed(voucherAmountAll, 3),
                        groupName: '合计'
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.div-header{
		display: flex;
		justify-content: flex-end;
	}
	.div-header .btn-font{
		font-size: 18px;
		line-height: 0 !important;
	}
</style>
